import Vue from 'vue'
import ReconnectingWebSocket from 'reconnecting-websocket'
import { getFrontConfig } from 'ow-service-component'

const socket = {
  namespace: true, // 设置命名空间
  state: {
    beatId: null, // 心跳定时任务id
    socket: null,
  },

  mutations: {
    openSocket (state, userId) {
      if (typeof WebSocket === 'undefined') {
        console.log('您的浏览器不支持WebSocket')
      } else {
        console.log('您的浏览器支持WebSocket')
        // todo userId应该使用userCenter的
        let baseUrl = getFrontConfig().GATEWAY_API
        let socketUrl = baseUrl.replace('http', 'ws') + '/im/user/' + userId
        console.log(socketUrl)
        state.socket = new ReconnectingWebSocket(socketUrl)
        // 打开事件
        state.socket.onopen = () => {
          state.socket = state.socket
          console.log('已连接服务器')
          state.beatId = setInterval(() => {
            if (state.socket) {
              state.socket.send(JSON.stringify({type: 'heartBeat'}))
            }
          }, 50000)
        }
        // 获得消息事件
        state.socket.onmessage = (msg) => {
          console.log('onmessage', msg)
          let messageObj = JSON.parse(msg.data)
          state.userMessage = messageObj
        }
        // 关闭事件
        state.socket.onclose = (e) => {
          state.socket = null
          console.log('websocket 断开：' + e.code + " " + e.reason + " " + e.wasClean)
          console.log('服务器连接断开')
          if (state.beatId) {
            clearInterval(state.beatId)
            state.beatId = null
          }
        }
        // 发生了错误事件
        state.socket.onerror = function () {
          console.log('websocket发生了错误')
        }
      }
    }
  },

  actions: {
  }
}

export default socket